module.exports = __webpack_public_path__ + "static/featuredBlockLayout2Back-a6089e1f7f5d4e38defb8ca2f08d9ffb.png";